import { render, staticRenderFns } from "./VectorColorProperties.vue?vue&type=template&id=44e23202"
import script from "./VectorColorProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./VectorColorProperties.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports